{
	"app_sidebar": {
		"menu": {
			"theme": "Tema"
		},
		"theme": {
			"dark": "Scuro",
			"light": "Chiaro",
			"system": "Sistema"
		},
		"user_menu": {
			"language": "Lingua",
			"language_no_results": "Nessuna lingua trovata",
			"language_search_placeholder": "Cerca lingua..."
		}
	},
	"async_pickers": {
		"selected_count_one": "1 selezionato",
		"selected_count_other": "{{count}} selezionati"
	},
	"auth_error_alert": {
		"close": "Chiudi"
	},
	"avatar": {
		"add_photo": "Aggiungi foto",
		"change_photo": "Cambia foto",
		"invalid_type": "Scegli un'immagine JPEG, PNG o WebP.",
		"remove_photo": "Rimuovi foto",
		"too_large": "Scegli un'immagine più piccola di 5 MB.",
		"upload_error": "Impossibile caricare la foto."
	},
	"data_table": {
		"column_menu": {
			"autosize_column": "Adatta larghezza colonna",
			"clear_sort": "Rimuovi ordinamento",
			"hide_column": "Nascondi colonna",
			"no_pin": "Nessun blocco",
			"pin_column": "Blocca colonna",
			"pin_left": "Blocca a sinistra",
			"pin_right": "Blocca a destra",
			"sort_asc": "Ordina crescente",
			"sort_desc": "Ordina decrescente",
			"trigger": "Opzioni colonna {{column}}"
		},
		"column_settings": {
			"drag_handle": "Riordina colonna",
			"no_results": "Nessuna colonna trovata",
			"pin_column": "Blocca {{column}}",
			"pin_left": "Blocca a sinistra",
			"pin_right": "Blocca a destra",
			"reset": "Ripristina",
			"search_placeholder": "Cerca colonne...",
			"show_all": "Mostra tutte",
			"toggle_visibility": "Mostra/nascondi {{column}}",
			"trigger": "Colonne",
			"unpin": "Sblocca"
		},
		"error": "Caricamento dei dati non riuscito",
		"loading_more": "Caricamento...",
		"no_results": "Nessun risultato",
		"pagination": {
			"go_to_page": "Vai a pagina {{page}}",
			"more_pages": "Altre pagine",
			"next": "Successivo",
			"previous": "Precedente",
			"rows_per_page": "Righe per pagina"
		},
		"resize_column": "Ridimensiona colonna",
		"select_all": "Seleziona tutte le righe",
		"select_row": "Seleziona riga",
		"sort_by": "Ordina per {{column}}"
	},
	"date_input": {
		"open_calendar": "Apri calendario",
		"validation": {
			"disabled_date": "Questa data non è disponibile",
			"invalid_date": "Inserisci una data valida",
			"max_date": "La data deve essere uguale o precedente a {{maxDate}}",
			"min_date": "La data deve essere uguale o successiva a {{minDate}}",
			"range": "La data deve essere compresa tra {{minDate}} e {{maxDate}}"
		}
	},
	"date_picker": {
		"cancel": "Annulla",
		"description": "Scegli una data dal calendario",
		"presets": {
			"last_7_days": "Ultimi 7 giorni",
			"last_month": "Mese scorso",
			"last_year": "Anno scorso",
			"this_month": "Questo mese",
			"this_week": "Questa settimana",
			"this_year": "Quest'anno"
		},
		"submit": "Conferma",
		"title": "Seleziona data"
	},
	"drop_zone": {
		"accepted_formats": "Accettati: {{formats}} · fino a {{size}}",
		"drag_and_drop_files": "Trascina e rilascia i file qui",
		"drop_files_here": "Rilascia i file qui"
	},
	"http_errors": {
		"account_disabled": "Account disattivato, contatta l'assistenza Unicasa.",
		"account_locked": "Troppe password sbagliate: l'account è bloccato per 15 minuti.",
		"admin_forbidden": "Non hai i permessi per eseguire questa azione amministrativa.",
		"admin_target_user_not_found": "L'utente amministrativo selezionato non è stato trovato.",
		"admin_user_already_deleted": "Questo utente amministrativo è già stato eliminato.",
		"asset_corrupted": "Non è stato possibile elaborare questo file. Caricalo di nuovo.",
		"asset_mime_type_not_allowed": "Questo tipo di file non è consentito.",
		"asset_not_found": "File non trovato.",
		"asset_ownership_error": "Non hai accesso a questo file.",
		"asset_size_too_large": "Questo file è troppo grande.",
		"asset_storage_missing": "L'archiviazione dei file non è disponibile.",
		"auth_credentials_missing": "Effettua l'accesso prima di continuare.",
		"auth_csrf_invalid": "Il token di sicurezza della sessione non è valido. Ricarica e riprova.",
		"auth_email_not_found": "Nessun account trovato con questo indirizzo email.",
		"auth_jwt_invalid": "La sessione di accesso non è valida o è scaduta. Effettua di nuovo l'accesso.",
		"auth_session_issue_failed": "Non è stato possibile completare l'accesso. Riprova.",
		"auth_token_invalid": "La sessione di accesso non è valida o è scaduta. Ricomincia.",
		"backoffice_admin_deleted": "Questo account amministratore è stato eliminato.",
		"backoffice_admin_not_found": "Account amministratore non trovato.",
		"backoffice_auth_credentials_missing": "Effettua l'accesso come admin prima di continuare.",
		"backoffice_change_password_otp_invalid": "Il codice via email non è valido. Riprova.",
		"backoffice_change_password_otp_unavailable": "I codici via email non sono disponibili per modificare questa password admin.",
		"backoffice_csrf_invalid": "Il token di sicurezza della sessione admin non è valido. Ricarica e riprova.",
		"backoffice_email_already_in_use": "Esiste già un account admin con questa email.",
		"backoffice_email_change_token_invalid": "La sessione di modifica dell'email admin non è valida o è scaduta.",
		"backoffice_email_otp_token_invalid": "La sessione di verifica è scaduta. Richiedi un nuovo codice.",
		"backoffice_invalid_email_or_password": "L'email o la password non sono validi.",
		"backoffice_invite_invalid": "Questo invito admin non è valido o è scaduto.",
		"backoffice_jwt_invalid": "La sessione admin non è valida o è scaduta. Effettua di nuovo l'accesso.",
		"backoffice_new_email_same_as_current": "La nuova email admin corrisponde a quella attuale.",
		"backoffice_no_change_password_method_available": "Non è disponibile alcun metodo per modificare questa password admin.",
		"backoffice_reset_password_session_missing": "La sessione di reimpostazione password amministrativa non è presente.",
		"backoffice_reset_password_token_invalid": "Il token di reimpostazione password amministrativa non è valido o è scaduto.",
		"backoffice_self_edit_forbidden": "Non puoi modificare qui il tuo account admin.",
		"backoffice_session_expired": "La sessione admin è scaduta. Effettua di nuovo l'accesso.",
		"backoffice_session_invalid": "La sessione admin non è più valida. Effettua di nuovo l'accesso.",
		"backoffice_session_issue_failed": "Non è stato possibile completare l'accesso. Riprova.",
		"call_already_published": "Il bando è già pubblicato: i dati della struttura non si possono più cambiare.",
		"call_data_changed": "I dati della struttura sono cambiati dopo il tuo controllo: la pagina si è aggiornata, controllali di nuovo.",
		"call_dates_locked": "Il bando è già aperto: le date non si possono più cambiare.",
		"call_document_incomplete": "Il bando non si può ancora scrivere: mancano dei dati della struttura (decreto, sedi, contatti per la privacy, PEC o date). Completali e riprova.",
		"call_document_text_unsupported": "Il testo del bando contiene caratteri che il documento non sa stampare ({{characters}}): correggi i testi della struttura (per esempio scrivi con lettere latine).",
		"call_end_before_start": "Il giorno di fine deve venire dopo l'apertura.",
		"call_not_closed": "La struttura ha un bando non ancora chiuso: il bando dell'anno dopo si apre quando tutti i suoi bandi sono chiusi.",
		"call_not_ready": "Il bando non si può ancora pubblicare: completa i passaggi che mancano.",
		"call_notice_changed": "Il testo del bando è cambiato mentre veniva scritto: niente è stato salvato, riprova.",
		"call_read_only": "Questo bando è in sola lettura: la struttura ha un bando più recente e il bando dell'anno prima non si cambia più.",
		"call_rules_changed": "Sono entrate in vigore regole del bando più recenti: la pagina si è aggiornata, controlla e riprova.",
		"call_start_in_past": "L'apertura del bando non può essere nel passato.",
		"credential_account_not_found": "Account con credenziali non trovato.",
		"default": "Ops! Qualcosa è andato storto.",
		"email_already_in_use": "Esiste già un account con questa email.",
		"email_change_token_invalid": "La sessione di modifica dell'email non è valida o è scaduta.",
		"email_not_verified": "Questo indirizzo email non è verificato.",
		"email_otp_token_invalid": "La sessione di verifica è scaduta. Richiedi un nuovo codice.",
		"email_password_disabled": "L'accesso con email e password è disabilitato.",
		"email_password_sign_up_disabled": "La registrazione con email e password è disabilitata.",
		"email_text_changed": "Il testo è stato modificato da un altro admin dopo che l'hai aperto: ricarica la pagina per vedere l'ultima versione.",
		"export_not_found": "Export non trovato.",
		"export_too_large_for_sync": "Questo export è troppo grande per il download diretto. Usa auto o email quando pronto.",
		"failed_to_create_session": "Impossibile creare la sessione.",
		"failed_to_create_user": "Impossibile creare l'utente.",
		"invalid_code": "Il codice non è valido.",
		"invalid_delete_account_otp": "Il codice di eliminazione account non è valido.",
		"invalid_email": "L'indirizzo email non è valido.",
		"invalid_token": "Il token non è valido o è scaduto.",
		"invalid_two_factor_cookie": "Il cookie di autenticazione a due fattori non è valido.",
		"mailbox_test_throttled": "Una prova è già partita da poco, o ne sono già partite cinque nell'ultima ora: aspetta qualche minuto e riprova.",
		"mfa_not_enabled": "L'autenticazione a due fattori non è abilitata per questo account.",
		"new_email_same_as_current": "La nuova email corrisponde a quella attuale.",
		"otp_expired": "Il codice è scaduto. Chiedine uno nuovo.",
		"otp_has_expired": "La password monouso è scaduta. Richiedi un nuovo codice.",
		"otp_invalid": "Il codice non è corretto. Controlla l'email e riprova.",
		"otp_issuance_throttled": "Troppe richieste di codice. Attendi prima di richiederne uno nuovo.",
		"otp_locked": "Troppi codici sbagliati: riprova tra 15 minuti.",
		"otp_not_enabled": "Le password monouso non sono abilitate.",
		"otp_rate_limited": "Hai chiesto troppi codici. Riprova più tardi.",
		"password_check_busy": "Il server sta controllando molte password in questo momento. Riprova tra qualche secondo.",
		"password_too_long": "La password è troppo lunga.",
		"password_too_short": "La password è troppo breve.",
		"pdf_render_unavailable": "Il servizio dei documenti è occupato, riprova tra qualche istante.",
		"permission_denied": "Il tuo account ha effettuato l'accesso, ma non dispone dei permessi necessari per visualizzare questa pagina.",
		"previous_year_accepting_applications": "Il bando dell'anno prima accetta ancora domande sui posti rimasti. Ferma quelle domande per pubblicare il bando nuovo.",
		"residence_photo_in_use": "Questa foto è già in un'altra struttura: caricala di nuovo per questa.",
		"residence_photo_uploads_pending": "Hai troppe foto caricate e non ancora aggiunte alla struttura: aggiungile o aspetta di riprovare più tardi.",
		"resolve_user_required": "È necessario risolvere un utente prima di continuare.",
		"resolved_user_invalid": "L'utente risolto non è valido.",
		"rules_missing_for_year": "Non sono ancora uscite le regole del bando per l'anno accademico dopo: il bando nuovo si apre quando ci sono.",
		"sending_anomaly_no_managers": "Questa residenza non ha nessun gestore attivo da avvisare.",
		"session_expired": "La sessione è scaduta. Effettua di nuovo l'accesso.",
		"session_invalid": "La sessione non è più valida. Effettua di nuovo l'accesso.",
		"session_not_found": "Sessione non trovata.",
		"session_not_fresh": "Esegui nuovamente l'autenticazione prima di continuare.",
		"session_required": "È richiesta una sessione valida.",
		"text_not_printable": "Un testo contiene caratteri che il documento non sa stampare ({{characters}}): correggilo, per esempio con lettere latine.",
		"too_many_attempts": "Troppi tentativi di accesso da questa rete. Riprova tra qualche minuto.",
		"too_many_attempts_request_new_code": "Troppi tentativi. Richiedi un nuovo codice.",
		"two_factor_not_enabled": "L'autenticazione a due fattori non è abilitata.",
		"unauthorized": "Non hai effettuato l'accesso. Effettua l'accesso per continuare.",
		"user_already_exists_use_another_email": "Esiste già un utente con questa email. Usa un altro indirizzo email.",
		"user_banned": "Questo account utente è stato bannato.",
		"user_deleted": "Questo account utente è stato eliminato.",
		"user_not_found": "Utente non trovato.",
		"validation_error": "Alcuni dei dati inseriti non sono validi."
	},
	"inline_filter_date": {
		"from": "Da {{date}}",
		"to": "Fino al {{date}}"
	},
	"inline_filters": {
		"clear": "Rimuovi filtro",
		"clear_all": "Rimuovi tutto"
	},
	"input_currency": {
		"empty": "Nessuna valuta trovata",
		"search": "Cerca valuta...",
		"select_currency": "Seleziona valuta",
		"validation": {
			"invalid_amount": "Inserisci un importo valido"
		}
	},
	"input_password": {
		"hide": "Nascondi password",
		"show": "Mostra password"
	},
	"input_phone": {
		"empty": "Nessun paese trovato",
		"search": "Cerca paese...",
		"select_country": "Seleziona paese",
		"validation": {
			"invalid_phone_number": "Inserisci un numero di telefono valido"
		}
	},
	"list_input_search": {
		"clear": "Cancella ricerca"
	},
	"otp_input": {
		"label": "Codice di 6 cifre"
	},
	"query_breadcrumbs": {
		"error": "Errore",
		"no_data": "Dettaglio"
	},
	"residence_service_groups": {
		"comfort": "Comfort",
		"common": "Spazi",
		"food_security": "Pasti e sicurezza",
		"mobility": "Sport e mobilità",
		"study": "Studio"
	},
	"residence_services": {
		"air_conditioning": "Aria condizionata",
		"bed_linen": "Biancheria",
		"bike_parking": "Parcheggio bici",
		"canteen": "Mensa",
		"cleaning": "Pulizie",
		"common_kitchen": "Cucina",
		"common_room": "Sala",
		"elevator": "Ascensore",
		"garden": "Giardino",
		"gym": "Palestra",
		"laundry": "Lavanderia",
		"library": "Biblioteca",
		"parking": "Parcheggio",
		"private_bathroom": "Bagno privato",
		"security": "Vigilanza",
		"shuttle": "Navetta",
		"sports_field": "Campo sportivo",
		"study_room": "Sala studio",
		"vending": "Distributori",
		"wifi": "Wi-Fi"
	},
	"validation": {
		"otp_length": "Il codice deve essere di 6 cifre."
	}
}
